<div class="bg-enrollment m-0 overflow-auto">
  <header>
    <div class="clearfix header-enrollment">
      <div class="container">
        <div class="logo-enrollment float-start my-3"></div>
        <!-- Contenedor del Dropdown -->
        <div class="dropdown float-end d-flex">
          <div class="text-muted py-4 pe-3">{{"DCO.enrollment_process" | translate}}</div>
          <button class="btn btn-link text-dark fw-semibold small dropdown-toggle d-flex align-items-center"
            type="button" (click)="menuAbierto = !menuAbierto; $event.stopPropagation()">
            <i class="fas fa-user-circle me-2 fa-2x"></i>
            {{ username ? username : ('Login' | translate) }}
          </button>
          <!-- Menú con clase dinámica 'show' de Bootstrap -->
          <ul class="dropdown-menu dropdown-menu-end shadow border-0" [class.show]="menuAbierto"
            style="right: 0; left: auto; background-color: white;">

            <!-- Selector de Idioma -->
            <li class="px-3 py-2" (click)="$event.stopPropagation()">
              <div class="d-flex align-items-center" style="min-width: 150px;">
                <i class="fas fa-globe me-2 text-muted"></i>
                <select class="form-select form-select-sm border-1" [(ngModel)]="selectedLanguage"
                  (change)="SetLanguage(selectedLanguage); menuAbierto = false">
                  <option *ngFor="let language of languages" [value]="language">
                    {{ language }}
                  </option>
                </select>
              </div>
            </li>

            <li>
              <hr class="dropdown-divider">
            </li>

            <!-- Opción de Logout / Login -->
            <li *ngIf="username; else loginLink">
              <button class="dropdown-item text-danger d-flex align-items-center"
                (click)="logOut(); menuAbierto = false">
                <i class="fas fa-sign-out-alt me-2"></i> {{"DCO.Title_SignOut" | translate}}
              </button>
            </li>

            <ng-template #loginLink>
              <li>
                <a class="dropdown-item d-flex align-items-center" routerLink="/login" (click)="menuAbierto = false">
                  <i class="fas fa-sign-in-alt me-2"></i> Login
                </a>
              </li>
            </ng-template>
          </ul>
        </div>
      </div>
    </div>
  </header>
  <div class="container">
    <div class="d-flex w-50 my-4 mx-auto">
      <div class="d-flex flex-fill">
        <div class="d-flex flex-column">
          <div class="rounded-circle bg-primary p-2 text-white fw-semibold text-center mx-auto"
            style="width: 40px; height: 40px;"><i class="fa-solid fa-check text-white"></i></div>
          <span class="text-sm mt-2 text-nowrap">{{"DCO.Enrollment_FillInData" |
            translate}}<!--Completar datos--></span>
        </div>
        <div class="mx-4 border-bottom border-4 border-primary w-100 mb-4"></div>
      </div>
      <div class="d-flex flex-fill">
        <div class="d-flex flex-column my-auto">
          <div class="rounded-circle bg-primary p-2 text-white fw-semibold text-center mx-auto"
            style="width: 40px; height: 40px;">2</div>
          <span class="text-sm mt-2 text-nowrap">{{"DCO.Enrollment_Documents" | translate}}<!--Documentos--></span>
        </div>
        <div class="mx-4 border-bottom border-4 border-light w-100 mb-4"></div>
      </div>
      <div class="d-flex flex-fill">
        <div class="d-flex flex-column my-auto">
          <div class="rounded-circle bg-primary p-2 text-white fw-semibold text-center mx-auto"
            style="width: 40px; height: 40px;">3</div>
          <span class="text-sm mt-2 text-nowrap text-muted">{{"DCO.Enrollment_Finish" |
            translate}}<!--Finalizar--></span>
        </div>
      </div>
    </div>
    <div class="alert alert-primary border-light d-flex mb-0">
      <div class="fa-stack pe-3">
        <i class="fa-regular fa-circle fa-stack-2x"></i>
        <i class="fa-solid fa-info fa-stack-1x"></i>
      </div>
      <div class="ps-3">
        {{ "DCO.Enrollment_Documents_PageDescription" | translate }}
        <!--Adjunta los documentos que utilizas habitualmente para defender tus disputas. Estos documentos serán utilizados automáticamente en la gestión de tus reclamaciones. Si lo prefieres, puedes saltar este paso y configurarlo más adelante.-->
      </div>
    </div>
    <div class="card px-4 pt-2">
      <div class="card-header px-0 pb-1 border-bottom border-light">
        <h5 class="text-primary text-lg"><i class="fa-regular fa-file-lines fa-lg"></i>&nbsp;&nbsp;{{
          "DCO.Enrollment_AddDocumentation" | translate }}<!--Añadir Documentos--></h5>
      </div>
      <div class="card-body px-0">
        <div class="alert alert-info border-light d-flex py-2">
          <div class="pe-3"><i class="fa-regular fa-file-lines fa-lg"></i></div>
          <div>
            <span class="text-primary fw-semibold">{{ "DCO.Enrollment_AttachDocumentation_InfoTitle" | translate
              }}<!--Documentación requerida--></span><br>
            <span class="text-muted text-xs">{{ "DCO.Enrollment_AttachDocumentation" | translate }}</span>
            <!--Puedes añadir múltiples documentos por tipo y asignarlos a comercios específicos.-->
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <!--<h5>{{ "DCO.Enrollment_DocumentDetails" | translate }}</h5>-->
            <div *ngIf="!loadCompleted" class="d-flex justify-content-center" style="position: absolute; left: 50%">
              <div class="spinner-border spinner-border-smtext-customer"></div>
            </div>
            <div class="border border-1 rounded-3 px-1 pt-1" *ngIf="loadCompleted">
              <div class="accordion bg-white" id="mainDocumentAccordion">
                <div *ngFor="let docType of documentAssignments | keyvalue"
                  class="accordion-item border-0 border-bottom">
                  <h6 class="accordion-header">
                    <div class="d-flex align-items-center bg-white">
                      <button class="accordion-button shadow-none fw-semibold py-2 bg-white text-dark" type="button"
                        (click)="toggleDocumentAccordion(docType.key)"
                        [class.collapsed]="openDocumentKey !== docType.key"
                        [attr.aria-expanded]="openDocumentKey === docType.key">
                        <span>
                          {{ "DCO.Enrollment_" + docType.key | translate }}
                        </span>
                        <button class="btn btn-link p-0 ms-3 border-0"
                          [disabled]="CheckDocumentAssignmentModalDisabled(docType.key, docType.value)"
                          (click)="ShowDocumentAssignmentModal(docType.key, docType.value); $event.stopPropagation()">
                          <i class="fa-solid fa-paperclip" style="color: #00bcd4;"></i>
                        </button>
                      </button>
                    </div>
                  </h6>
                  <div class="accordion-collapse collapse" [class.show]="openDocumentKey === docType.key">
                    <div class="accordion-body bg-light">
                      <div *ngFor="let doc of docType.value; let i = index"
                        class="border-bottom border-white last-child-border-0">
                        <div class="d-flex p-2 align-items-center">
                          <div class="pe-3">
                            <button type="button" class="btn btn-link my-0 p-1"
                              (click)="DocumentAssignmentClear(docType.key, i, doc.commerceFileId)">
                              <i class="fas fa-trash-alt fa-lg text-danger"></i>
                            </button>
                          </div>
                          <div class="fw-semibold pe-4 flex-grow-1">
                            {{ doc.fileName }}
                          </div>
                          <div class="p-1">
                            <span *ngFor="let contact of doc.contacts"
                              class="badge rounded-pill bg-secondary py-2 px-3 me-1">
                              {{ contact.commerceNumber }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="d-flex flex-row-reverse">
            <div *ngIf="!showInfoEnrollment" class="mx-1 my-3">
              <button class="btn btn-primary w-100" (click)="updateEnrollment()" [disabled]="DisableContinue()">
                {{ "DCO.Enrollment_Continue" | translate }}
              </button>
            </div>
            <div *ngIf="!showInfoEnrollment" class="mx-1 my-3">
              <button class="btn btn-outline-primary w-100" data-bs-toggle="modal" data-bs-target="#questionSkipModal">
                {{ "DCO.Enrollment_SkipStep" | translate }}
              </button>
            </div>
            <div class="mx-1 my-3">
              <button class="btn btn-outline-primary w-100" (click)="GoBack()">
                {{ "DCO.Enrollment_GoBack" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- MODAL ASSING DOCUMENTS -->
<div class="modal fade" #assigDocumentModal id="assigDocumentModal">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <!-- <h6 class="modal-title">{{ "DCO.Enrollment_Documents_Assign" |translate }}</h6> -->
        <h6>
          {{ "DCO.Enrollment_" + modalSelectedType | translate }}
        </h6>
        <!--Aqui iría el boton deslizante-->
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cancelar"></button>
      </div>
      <div class="modal-body">
        <form>
          <div class="mb-3">
            <div class="d-flex flex-column mb-3">
              <label class="fw-semibold">{{ "DCO.ClientFileConfiguration_AddFiles" | translate
                }}</label>
              <div class="d-flex my-2">
                <div>
                  <button class="btn btn-outline-primary fw-semibold text-sm m-0" type="button"
                    (click)="modalFileInput.click()">
                    <i class="fa-solid fa-arrow-up-from-bracket fa-lg"></i>&nbsp;&nbsp;{{
                    "DCO.Enrollment_DocumentUpload" | translate }}
                  </button>
                </div>
                <div>
                  <div *ngIf="documentAssignFileBase64 != ''" class="py-1">
                    <span class="ps-4 fw-semibold">{{ documentAssignName }}</span><span class="ps-3 text-muted">({{
                      documentAssignSize }}KB)</span>
                    <button type="button" class="btn btn-link m-0 p-1 ms-3" (click)="ClearUploadedDocument()">
                      <i class="fas fa-trash-alt fa-lg text-danger"> </i>
                    </button>
                  </div>
                  <div *ngIf="documentAssignFileBase64 == '' && documentAssignFileError == false
                        " class="text-muted py-2 ps-3">
                    {{ "DCO.Enrollment_NoDocumentAssigned" | translate }}
                  </div>
                  <div *ngIf="documentAssignSizeFileError == true" class="text-danger py-2 ps-3">
                    {{ "DCO.File_SizeError" | translate }}
                  </div>
                  <div *ngIf="documentAssignExtensionFileError == true" class="text-danger py-2 ps-3">
                    {{ "DCO.File_ExtensionError" | translate }}
                  </div>
                </div>
              </div>
              <p class="text-muted text-sm fst-italic">{{ "DCO.Enrollment_DocumentUploadInfo" | translate
                }}<!-- Formatos permitidos: .pdf, .docx, .doc, .jpg, .jpeg, .png | Tamaño máximo: 10MB --></p>
            </div>
            <input type="file" #modalFileInput class="file-upload invisible" style="display: none;"
              onchange="// console.log(event.target.files)" (change)="onModalDocumentUpload($event)" />
            <div class="mb-3">
              <p class="fw-semibold mb-2">{{ "DCO.Enrollment_AvailableCommerceList" | translate }}</p>
              <p class="text-muted text-sm mb-2 fst-italic">{{
                "DCO.Enrollment_Documents_FileMessage" | translate
                }}</p>
              <div class="checkbox-container">
                <div class="content">
                  <div class="checkbox-group">
                    <div class="option">
                      <ul class="list-group" style="height: 200px; overflow: auto">
                        <li class="pb-3">
                          <label class="btn btn-primary text-sm fw-semibold"><input type="checkbox" id="all" name="all"
                              value="all" [checked]="false" [(ngModel)]="boolCheckedAll"
                              (change)="onCheckedContact(-1, $event)" class="form-check-input" />
                            &nbsp;&nbsp;{{ "DCO.Enrollment_ALL" | translate }} </label>
                        </li>
                        <li *ngFor="let contact of lstContactsInModal" class="border-bottom ps-4 py-2">
                          <label class="form-check-label"><input type="checkbox" id="{{ contact.lastUpdateBy }}"
                              name="{{ contact.contactId }}" value="{{ contact.contactId }}" [checked]="
                              this.documentAssignSelectedContacts[
                                contact.contactId
                              ]
                            " (change)="
                              onCheckedContact(contact.contactId, $event)
                            " class="form-check-input me-4" />
                            <span class="me-4">{{ contact.commerceNumber }}</span>
                            {{ contact.commerceName }} </label>
                        </li>
                        <br />
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="alert alert-primary border-light d-flex mb-3">
              <div class="fa-stack pe-3 opacity-75">
                <i class="fa-regular fa-circle fa-stack-2x"></i>
                <i class="fa-solid fa-info fa-stack-1x"></i>
              </div>
              <div class="ps-3 text-muted">
                {{"DCO.Enrollment_Documents_FileMessageInfo" | translate }}
                <!--Esta será la documentación base que se utilizará en las alegaciones de las disputas por lo que te recordamos la importancia de que siempre esté actualizada. -->
              </div>
            </div>

          </div>
        </form>
      </div>
      <div class="modal-footer text-end">
        <button type="button" data-bs-dismiss="modal" class="btn btn-outline-primary text-sm fw-semibold">
          {{ "DCO.Enrollment_Cancel" | translate }}
        </button>
        <button type="button" class="btn btn-primary text-sm fw-semibold" [disabled]="
                  documentAssignFileBase64 == '' || !boolAnyContactsAssigned
                " (click)="SaveDocumentAssigment()">
          {{ "DCO.Enrollment_Accept" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
<!-- MODAL DOCUMENTOS AÑADIDOS -->
<div class="modal fade" #postFilemodal data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-sm">
    <div class="modal-content">
      <div class="modal-body text-center">
        <i class="fas fa-check fa-3x text-info"></i>
        <h5 class="modal-title" id="confirmModalLabel">
          {{ "DCO.Enrollment_DocumentAdded" | translate }}
        </h5>
        <h6>{{ "DCO.Enrollment_DocumentHaveBeenAdded" | translate }}</h6>
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal">
          {{ "DCO.MassiveInformation_Accept" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
<!-- MODAL CONFIRMACION SALTAR PASO -->
<div class="modal fade" id="questionSkipModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-sm">
    <div class="modal-content">
      <div class="modal-body text-center">
        <i class="fas fa-question-circle fa-3x text-info"></i>
        <h5 class="modal-title" id="confirmModalLabel">
          {{ "DCO.Enrollment_SkipSettings" | translate }}
        </h5>
        <h6>{{ "DCO.Enrollment_SkipStepQuestion" | translate }}</h6>
        <button class="btn btn-outline-danger" data-bs-dismiss="modal">
          {{ "DCO.MassiveInformation_Cancel" | translate }}
        </button>
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal" data-bs-target="#skipModal"
          (click)="updateEnrollment()">
          {{ "DCO.MassiveInformation_Accept" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>